// @flow
import React, { Fragment, Component } from 'react';
import type { Status } from 'types/Status';

import Breadcrumb from 'components/fragments/Breadcrumb';
import ContactFormGrandSoutienContainer from 'containers/contact/ContactFormGrandSoutienContainer';
import type { BlocContent } from 'types/NewsletterBloc';

type Props = {
  title: string,
  featured_media: {
    src: string,
    legend: string
  },
  meta_description: string,
  status: Status,
  description: Array<BlocContent>,
  match: {
    params: {
      slug: string
    }
  },
  pageSlug: string
};

class PageGrandSoutien extends Component<Props> {

  render() {
    const {
      featured_media,
      title,
      description,
      meta_description
    } = this.props;

    return (
      <Fragment>
        <section className="banner banner--bigNoAfter banner--center">
          <div className="banner__thumbnail img-blue-dark" style={{ 
            backgroundImage: featured_media.src ? `url(${featured_media.src})` : '' 
          }} />
          <div className="container">
            <Breadcrumb elements={[{ name: 'accueil', to: '/' }, title]} isDark />
            <h1 className="ft-h2">{title}</h1>
            {meta_description &&
            <p className="banner__desc">
              {meta_description}
            </p>}
          </div>
        </section>
        <div className="container">
          <div className="row mb-lg-8 mb-4">
            <div className="col col-lg-8 col-lg-offset-2">
              <div className="box block-contact mt-5">
                <div className="form-contact block-contact__form">
                  <ContactFormGrandSoutienContainer content={description} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default PageGrandSoutien;
